import { gql } from '@apollo/client';

export const GET_X_TIME_SERVICES = gql`
  query getXtimeServices(
    $activeIntegrationId: String!
    $make: String
    $model: String
  ) {
    xtimeServices(
      activeIntegrationId: $activeIntegrationId
      vehicleMake: $make
      vehicleModel: $model
    ) {
      serviceName
      opcode
      price
      comment
      serviceCategoryId
      serviceCategoryName
      sabCode
    }
  }
`;
